<template>
  <div>
   <z-dialogo ref="dialogo" titulo="Balanços" :dividers="true" largura="1000px" altura="500px" scrollable no-padding>
      <div slot="texto">
        <z-loading :loading="loading" height="100px" color="primary"></z-loading>
        <v-data-table
          :headers="headers"
          :items="balancos"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr @click="selecionar(item)" style="cursor: pointer">
              <td>
                <v-icon v-if="item.id == balanco_id" color="primary">mdi-check-circle</v-icon>
              </td>
              <td>{{ item.descricao }}</td>
              <td>
                <v-chip small dark color="green" v-if="item.data_inicio && item.data_termino">Finalizado</v-chip>
                <v-chip small dark color="blue" v-else-if="item.data_inicio">Em andamento</v-chip>
                <v-chip small dark color="red" v-else>Não iniciado</v-chip>
              </td>
              <td>{{ item.data_inicio | dataHoraBR }}</td>
              <td>{{ item.data_termino | dataHoraBR }}</td>
              <td class="text-center">
                <v-icon @click.stop="editar(item)">mdi-pencil</v-icon>
                <!-- <v-btn icon v-if="!item.data_inicio" @click.stop="excluir(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <div slot="actions_left">
        <v-btn depressed color="primary" @click="novo">Novo Balanço</v-btn>
      </div>

      <div slot="actions_right">
        <v-btn text @click="$refs.dialogo.fechar()">Fechar</v-btn>
      </div>

    </z-dialogo>

    <z-dialogo ref="dialogoBalanco" titulo="Balanco" dividers>

      <template v-slot:conteudo>
        <v-row>
          <v-col cols="12">
            <z-text-field 
              v-model="balanco.descricao"
              ref="descricao" 
              label="Descrição" 
              filled 
              dense
              upper
              @keypress.enter="salvar"
            ></z-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:actions_right>
        <v-btn text :disabled="salvando" @click="$refs.dialogoBalanco.fechar()" :disable="salvando">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="salvar" :loading="salvando">Salvar</v-btn>
      </template>
    </z-dialogo>

  </div>
</template>

<script>
  import balancoApi from "@/app/services/balanco";

  import config from "@/app/config";
  import { createLocalStorage } from "@/app/utils/LocalStorage";
  const storage = createLocalStorage(config);

  export default {
    name: 'DialogoBalancos',

    data() {
      return {
        loading: false,
        balancos: [],
        balanco: {
          descricao: ''
        },
        headers: [
          { text: '', value: '', width: '50px' },
          { text: 'Descrição', value: 'descricao'},
          { text: 'Status', value: '' },
          { text: 'Início', value: 'data_inicio' },
          { text: 'Término', value: 'data_termino' },
          { text: '', value: '', align: 'center', width: '100px' },
        ],
        salvando: false,
        balanco_id: null,
      }
    },

    methods: {
      async abrir() {
        this.balanco_id = storage.get("balanco_id");
        this.balancos = await balancoApi.listar();
        this.$refs.dialogo.abrir();
      },

      fechar() {
        this.$refs.dialogo.fechar();
      },

      selecionar(balanco) {
        this.$emit('selecionar', balanco);
        this.$refs.dialogo.fechar();
      },

      novo() {
        this.balanco = {
          descricao: ''
        }
        this.$refs.dialogoBalanco.abrir();
        setTimeout(() => {
          this.$refs.descricao.focus();
        }, 100);
      },

      editar(balanco) {
        this.balanco = balanco;
        this.$refs.dialogoBalanco.abrir();
        setTimeout(() => {
          this.$refs.descricao.focus();
        }, 100);
      },

      async salvar() {
        this.salvando = true;
        let balanco;
        if (this.balanco.id) {
          await balancoApi.atualizar(this.balanco);
        } else {
          balanco = await balancoApi.salvar(this.balanco);
        }

        this.balancos.unshift(balanco);

        this.salvando = false;

        this.$refs.dialogoBalanco.fechar();
      },

    },
  }
</script>

<style lang="scss" scoped>

</style>